import * as React from 'react';
import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useLocation, useNavigate } from 'react-router-dom';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import FlatwareIcon from '@mui/icons-material/Flatware';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import api from "../../utils/api";
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import { useEffect } from "react";
import * as util from "../../utils/util";


import tab04 from "../../assets/images/tab_01.png"


const counselInit = {
  id: '',
  title: '',
  content: '',
  createDate: '',
  answer: '',
  type: '',
  category: '',
  answerDate: '',
  memberId: '',
  image_url: ''
}

const CreateCounsel = () => {
  const navigate = useNavigate();
  const [alignment, setAlignment] = React.useState('EXERCISE');
  const [contentLength, setContentLength] = React.useState(0);
  const [counsel, setCounsel] = React.useState(counselInit);
  // const { state } = useLocation();
  // const { supportId } = state;
  const location = useLocation();
  const supportId = location?.state?.supportId ?? null;

  // useEffect(() => {
  //   if(supportId > 0){  // 수정을 통해 들어왔을 때, 기존 상담 정보 조회
  //     getCounsel();
  //   }
  // }, []);

  const handleAlignment = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null,
  ) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };

  // function getCounsel(){
  //   api.get(`app/api/v1/AP_003_002?support_id=${supportId}`).then(res => {
  //     setCounsel(res.data.result_data.support_item);
  //     setContentLength(res.data.result_data.support_item.content.length);
  //     setAlignment(res.data.result_data.support_item.category);
  //   }).catch(function (error) {
  //     console.log(error)
  //   });
  // }

  function handleClickCreateCounsel(data: any) {
    // data.cid = supportId;
    // data.type = 'MY';
    // data.category = alignment;
    // data.image_url = '';
    console.log(data);

    const sendItems = {
      cusId: localStorage.getItem('userCusID'),
      title: data.title,
      question: data.content,
    }

    api.post(`customer/api/v1/CU_008_002`, sendItems).then((res: any) => {
      if (res.data.message == 'success') {
        alert('상담 등록이 완료되었습니다.');
        navigate('/check/Counsel');
      }
    }).catch(function (error) {
      console.log(error)
    });
  }

  const img = {
    display: 'flex', p: 0, backgroundImage: `url(${tab04})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
  }


  return (
    <Container className="container">
      <Box sx={img} >
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900 }}>
              고객센터
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ead3d', fontWeight: 500, }} gutterBottom>
              1:1 문의
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <FormContainer
        values={{
          cid: counsel.id, category: counsel.category,
          title: counsel.title, content: counsel.content, type: counsel.type, image_url: counsel.image_url
        }}
        onSuccess={data => handleClickCreateCounsel(data)}
      >

        {/* <Stack direction="row" spacing={0} sx={{ mt: 2 , width: '80%', mr : 'auto',  ml : 'auto'}}>
          <ToggleButtonGroup
            value={alignment}
            exclusive
            onChange={handleAlignment}
            aria-label="counsel"
            sx={{ width: '100%', bgcolor:'#fff' }}
          >
  
            <ToggleButton value="EXERCISE" key="EXERCISE" aria-label="EXERCISE" sx={toggleBtn}>
              <FitnessCenterIcon fontSize='small' />
              <Typography>운동</Typography>
            </ToggleButton>
            <ToggleButton value="HEALTH" key="HEALTH" aria-label="HEALTH" sx={toggleBtn}>
              <HealthAndSafetyIcon fontSize='small' />
              <Typography>건강</Typography>
            </ToggleButton>
            <ToggleButton value="DIET" key="DIET" aria-label="DIET" sx={toggleBtn}>
              <FlatwareIcon fontSize='small' />
              <Typography>식이</Typography>
            </ToggleButton>
  
          </ToggleButtonGroup>
        </Stack> */}


        <Box
          component="form"
          sx={{
            mt: 4,
            '& > :not(style)': { m: 0, mb: 3, width: '100%' },
            width: '80%', mr: 'auto', ml: 'auto'
          }}
          noValidate
          autoComplete="off"
          className='White_box'
        >
          <TextFieldElement
            name="title"
            id="input-title" label="제목"
            fullWidth
            onChange={(e: any) => {
              setCounsel((prev) => true ? { ...prev, title: e.target.value } : prev);
            }}
            multiline
            maxRows={2}
            inputProps={{ maxLength: 50, value: counsel.title }}
            rules={{
              required: '제목은 필수 입력입니다.',
            }}
            sx={{
              '& textarea': { bgcolor: '#fff!important' },
              '& .MuiInputBase-root': { bgcolor: '#fff' },
              '& .MuiFormLabel-root.MuiInputLabel-root.Mui-focused': { color: '#0d6703' },
              '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#0d6703' }
            }}
          />
          <TextFieldElement
            name="content"
            id="input-content" label="내용"
            fullWidth
            onChange={(e: any) => {
              setCounsel((prev) => true ? { ...prev, content: e.target.value } : prev);
              setContentLength(e.target.value.length);
            }}
            multiline
            rows={12}
            inputProps={{ maxLength: 250, value: counsel.content }}
            rules={{
              required: '내용은 필수 입력입니다.',
            }}
            sx={{
              '& textarea': { bgcolor: '#fff!important' },
              '& .MuiInputBase-root': { bgcolor: '#fff' },
              '& .MuiFormLabel-root.MuiInputLabel-root.Mui-focused': { color: '#0d6703' },
              '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#0d6703' }
            }}
          />
          <Typography sx={{ fontSize: 12, color: '#777', textAlign: 'right', mt: -2 }}>({contentLength}/250자)</Typography>
        </Box>


        {/*
        <Box sx={{mt:4}}>
          <Typography sx={{fontSize:16, mb:2 }}>사진 첨부</Typography>
          <form>
            <Typography sx={labelStyle}>이미지 추가</Typography>
            <Input
              type="file"
              id="fileImg"
              // sx={inputStyle}
            />
          </form>
          <Typography sx={{fontSize:12, color:'#777', mt:1}}>사진 1장 등록 가능</Typography>
        </Box>
        */}

        <Box sx={BtnStyle}>
          <Button variant="contained" sx={BottomBtnStyle} type={'submit'}>
            등록
          </Button>
        </Box>

      </FormContainer>

      <Bottom />
    </Container>
  );
}



const toggleBtn = {
  p: 1,
  flex: '1 1 auto',
  '& .MuiSvgIcon-root': { pl: 1 },
  '& p': { fontSize: 14, pl: 1, pr: 1 },
  '&.Mui-selected': { bgcolor: '#0d6703!important' },
  '&.Mui-selected svg': { color: '#fff' },
  '&.Mui-selected p': { fontWeight: 700, color: '#fff' }
}

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  mt: 3,
  boxSizing: 'border-box',
  pb: 3
};

const BottomBtnStyle = {
  width: '20%',
  bgcolor: '#0d6703',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #0d6703',
  ':hover': {
    backgroundColor: '#074300',
    borderColor: '#074300',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

const labelStyle = {
  display: 'inline-block',
  width: '90px',
  height: '90px',
  background: 'url("src/assets/icon-add-photo.svg") no-repeat',
  backgroundPosition: 'center',
  border: '1px solid #ccc',
  borderRadius: '10px',
  cursor: 'pointer',
}

// const inputStyle= {
//   display: 'none'
// }

export default CreateCounsel;